import { render, staticRenderFns } from "./powerValueView2.vue?vue&type=template&id=3da77448&scoped=true&"
import script from "./powerValueView2.vue?vue&type=script&lang=js&"
export * from "./powerValueView2.vue?vue&type=script&lang=js&"
import style0 from "./powerValueView2.vue?vue&type=style&index=0&id=3da77448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da77448",
  null
  
)

export default component.exports